export default "assets/gites-logo-e41ed8e6.png";